// extracted by mini-css-extract-plugin
export default {"link":"SmallBtn_link__0T3Iv","text":"SmallBtn_text__CPWzj","icon":"SmallBtn_icon__bgiTQ"};